import React from 'react';
import { styles, colors } from '../styles/styles';

/**
 * Elegant navigation tabs with premium Apple-inspired design
 * Shows only icons without text labels
 * Note: "inbox" ID is used for the Drafts tab
 */
const Tabs = ({ activeTab, onTabChange }) => {
    return (
        <div style={styles.tabs}>
            <button
                onClick={() => onTabChange("inbox")}
                style={{
                    ...styles.tab(activeTab === "inbox"),
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative',
                }}
            >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle 
                        cx="12" 
                        cy="12" 
                        r="10" 
                        stroke={activeTab === "inbox" ? colors.accent.white : colors.textSecondary} 
                        strokeWidth="2"
                    />
                    <path 
                        d="M12 8v6" 
                        stroke={activeTab === "inbox" ? colors.accent.white : colors.textSecondary} 
                        strokeWidth="2" 
                        strokeLinecap="round"
                    />
                    <path 
                        d="M9 13l3 3 3-3" 
                        stroke={activeTab === "inbox" ? colors.accent.white : colors.textSecondary} 
                        strokeWidth="2" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                    />
                </svg>
            </button>
            <button
                onClick={() => onTabChange("library")}
                style={{
                    ...styles.tab(activeTab === "library"),
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g transform="translate(0, 2)">
                        <path
                            d="M6 2v14M11 2v14"
                            stroke={activeTab === "library" ? colors.accent.white : colors.textSecondary}
                            strokeWidth="2"
                            strokeLinecap="round"
                        />
                        <path
                            d="M16 2v14h4V6l-4-4z"
                            stroke={activeTab === "library" ? colors.accent.white : colors.textSecondary}
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            fill="none"
                        />
                    </g>
                </svg>
            </button>
        </div>
    );
};

export default Tabs; 